import React from 'react';

const styles = {
  page: {
    width: '210mm',
    minHeight: '297mm',
    background: '#ffffff',
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    padding: '25mm',
    lineHeight: 1.4,
    fontSize: '10.5pt',
    color: '#111',
    boxSizing: 'border-box'
  },
  name: {
    fontSize: '30pt',
    fontWeight: 700,
    marginBottom: '8pt'
  },
  contactBlock: {
    display: 'grid',
    gap: '2pt',
    marginBottom: '16pt',
    fontSize: '9.5pt'
  },
  sectionTitle: {
    fontSize: '12.5pt',
    fontWeight: 700,
    letterSpacing: '0.4px',
    marginTop: '18pt',
    marginBottom: '8pt',
    textTransform: 'uppercase'
  },
  summaryText: {
    marginBottom: '12pt'
  },
  threeCol: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '15mm',
    marginTop: '8pt'
  },
  subTitle: {
    fontSize: '10.5pt',
    fontWeight: 600,
    marginBottom: '2pt'
  },
  metaText: {
    fontSize: '10pt',
    color: '#222'
  },
  list: {
    margin: '6pt 0 0 14pt',
    padding: 0
  },
  listItem: {
    marginBottom: '4pt'
  },
  skillGroup: {
    marginBottom: '10pt'
  }
};

const CVPreview = ({ data }) => {
  if (!data) return null;

  return (
    <div style={styles.page} className="cv-print-page">
      <style>{`
        @page {
          size: A4;
          margin: 25mm;
        }
        .cv-print-page {
          width: 210mm;
          min-height: 297mm;
          background: #ffffff;
        }
        .cv-print-page * {
          box-sizing: border-box;
          text-align: left;
        }
      `}</style>
      <div style={styles.name}>{data.name}</div>

      <div style={styles.contactBlock}>
        {data.address && <div>{data.address}</div>}
        {data.phone && <div>{data.phone}</div>}
        {data.email && <div>{data.email}</div>}
        {data.website && <div>{data.website}</div>}
        {data.social && <div>{data.social}</div>}
      </div>

      {data.summary && (
        <>
          <div style={styles.sectionTitle}>Profesyonel Özet</div>
          <div style={styles.summaryText}>{data.summary}</div>
        </>
      )}

      <div style={styles.threeCol}>
        <div>
          <div style={styles.sectionTitle}>Eğitim</div>
          {data.education && data.education.length > 0 ? (
            data.education.map((edu, index) => (
              <div key={index} style={{ marginBottom: '12px' }}>
                {edu.degree && <div style={styles.subTitle}>{edu.degree}</div>}
                {edu.school && <div style={styles.metaText}>{edu.school}</div>}
                {edu.date && <div style={styles.metaText}>{edu.date}</div>}
              </div>
            ))
          ) : (
            <div style={styles.metaText}>-</div>
          )}
        </div>

        <div>
          <div style={styles.sectionTitle}>İş Deneyimi</div>
          {data.experience && data.experience.length > 0 ? (
            data.experience.map((exp, index) => (
              <div key={index} style={{ marginBottom: '12px' }}>
                {exp.company && <div style={styles.subTitle}>{exp.company}</div>}
                {exp.role && <div style={styles.metaText}>{exp.role}</div>}
                {exp.date && <div style={styles.metaText}>{exp.date}</div>}
              </div>
            ))
          ) : (
            <div style={styles.metaText}>-</div>
          )}
        </div>

        <div>
          <div style={styles.sectionTitle}>Ödüller</div>
          {data.awards && data.awards.length > 0 ? (
            <ul style={styles.list}>
              {data.awards.map((award, index) => (
                <li key={index} style={styles.listItem}>{award}</li>
              ))}
            </ul>
          ) : (
            <div style={styles.metaText}>-</div>
          )}
        </div>
      </div>

      <div style={{ ...styles.sectionTitle, marginTop: '24pt' }}>Beceriler/Yetenekler</div>
      {data.skills && data.skills.length > 0 ? (
        data.skills.map((group, index) => (
          <div key={index} style={styles.skillGroup}>
            <div style={styles.subTitle}>{group.title}</div>
            {group.items && group.items.length > 0 && (
              <ul style={styles.list}>
                {group.items.map((item, idx) => (
                  <li key={idx} style={styles.listItem}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))
      ) : (
        <div style={styles.metaText}>-</div>
      )}
    </div>
  );
};

export default CVPreview;
